import { render, staticRenderFns } from "./CookieBanner.vue?vue&type=template&id=cb6be6b0&scoped=true&"
import script from "./CookieBanner.vue?vue&type=script&lang=ts&"
export * from "./CookieBanner.vue?vue&type=script&lang=ts&"
import style0 from "./CookieBanner.vue?vue&type=style&index=0&id=cb6be6b0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb6be6b0",
  null
  
)

export default component.exports